import type Icon from "@expo/vector-icons/MaterialCommunityIcons";

export type IconType = keyof typeof Icon.glyphMap;
